import { isEqual } from "lodash";

import { meetingFrequency, recurrenceValue } from "@helpers/constants";

export const getRecurrenceValue = (recurrence: any) => {
  if (!recurrence) {
    return recurrenceValue.none;
  }
  if (recurrence.frequency === meetingFrequency.weekly) {
    if (isEqual(recurrence.byWeekDay, [0, 1, 2, 3, 4])) {
      return recurrenceValue.weekdays;
    }
    return recurrenceValue.weekly;
  }
  if (recurrence.frequency === meetingFrequency.monthly) {
    if (recurrence.byMonthDay?.length > 0) {
      return recurrenceValue.monthlyMonthDay;
    }
    return recurrenceValue.monthlyWeekDay;
  }
  return recurrence.frequency;
};
